const URL_PARAMS = {
  ACCOMMODATION_TYPE_IDS: 'accommodationTypeIds',
  CURRENCY: 'currency',
  DESTINATIONS: 'destinations',
  DURATIONS: 'durations',
  FROM_DATE: 'fromDate',
  INCLUSIONS: 'inclusions',
  MATCHES: 'matches',
  PACKAGE_TYPES: 'packageTypes',
  PAGE: 'page',
  PRICE_FROM: 'priceFrom',
  PRICE_TO: 'priceTo',
  RESULTS_PER_PAGE: 'resultsPerPage',
  SITE_KEY: 'siteKey',
  SORT_ORDER: 'sortOrder',
  TOURNAMENTS: 'tournaments',
};

export default URL_PARAMS;
